/**
 * ROOFNOW (pre-deploy QA, Nov 1 2026): the logo stored in Firebase is a
 * generated placeholder, 1920x694 with the artwork in the middle and wide
 * transparent margins all round, so at the header width the wordmark printed
 * ~20px tall next to a ~40px HomeCam. While that exact image is the live one,
 * the report prints the same artwork trimmed (`roofnowTrimmed`, bundled on the
 * web side because common/ cannot import images). Any other image set in
 * Firebase (the real logo, once Jaron sends it) is used as is. Firebase is
 * never written.
 */
const ROOFNOW_PADDED_PLACEHOLDER = {
  length: 110470,
  tail: 'MGDAgAEDBgwYMGDAgIEHAm00o26/OhYoAAAAAElFTkSuQmCC',
} as const

export const isRoofnowPaddedPlaceholder = (logo: string): boolean =>
  logo.length === ROOFNOW_PADDED_PLACEHOLDER.length &&
  logo.endsWith(ROOFNOW_PADDED_PLACEHOLDER.tail)

export const reportContractLogo = (
  shortName: string,
  liveLogo: string,
  homenowGray: string,
  roofnowTrimmed?: string,
): string => {
  if (shortName === 'HNNV') return homenowGray
  if (
    shortName === 'ROOFNOW' &&
    roofnowTrimmed &&
    isRoofnowPaddedPlaceholder(liveLogo)
  )
    return roofnowTrimmed
  return liveLogo
}

/**
 * Width (px) of the contract-header logo.
 *
 * HOMENOW is a wide, short wordmark (~4.8:1): at the 128px "medium" width it
 * rendered ~27px tall, half the height of HomeCam next to the same company box
 * (Jaron, Oct 30, "HOMENOW logo is too small"). Medium HOMENOW gets the large
 * width instead, which lands it at about the same height as the other brands.
 * ROOFNOW, trimmed (see above), has the same shape (~4.7:1) and gets the same.
 *
 * M+S Electric is a single line of lettering (~10:1): at 200px it printed 19px
 * tall, a third of HomeCam (pre-deploy QA, Nov 1). 300px brings it to ~29px,
 * its letters as tall as the HomeCam/HOMENOW wordmarks.
 */
export const contractLogoWidth = (
  shortName: string,
  size: 's' | 'm' | 'l',
): number => {
  if (shortName === 'MSE') return 300
  if (size === 'm')
    return shortName === 'HNNV' || shortName === 'ROOFNOW' ? 200 : 128
  return 200
}
